// YunIcon.js

import React from 'react'
import './YunIcon.css';

// sprite 已内联到 index.html，无需 require.context

const YunIcon = function(props) {
    const classes = props.iconClass ? `svg-icon ${props.iconClass}` : `svg-icon`
    return (
        <svg onClick={props.onClick} className={classes} aria-hidden="true">
            <use xlinkHref={'#icon-' + props.icon}></use>
        </svg>
    )
}

export default YunIcon;
